import React from 'react'
import GraphemeSplitter from 'grapheme-splitter'

export default function stringWithWBR (text) {
  const addWBRAfter = [',', '.', '/', '\\']
  const naturalSplit = [' ', '-']
  const splitter = new GraphemeSplitter()

  let returnArray = []
  let final = ''
  let sinceSplit = 0
  let i = 0

  // Use GraphemeSplitter to correctly handle emojis and other multi-byte characters
  const characters = splitter.splitGraphemes(text)

  characters.forEach(letter => {
    if (addWBRAfter.indexOf(letter) >= 0 || sinceSplit >= 30) {
      sinceSplit = 0
      final += letter
      returnArray.push(<span key={i++}>{final}</span>)
      returnArray.push(<wbr key={i++} />)
      final = ''
    } else if (naturalSplit.indexOf(letter) >= 0) {
      sinceSplit = 0
      final += letter
    } else {
      sinceSplit += 1
      final += letter
    }
  })

  if (final) {
    returnArray.push(<span key={i++}>{final}</span>)
  }

  return <span>{returnArray}</span>
}
